<div class="Flex--row Statistikmonitor">



    <FloatingWindow @closeButtonClick="showGlossary=false" v-if="showGlossary" title="Glossar" :dockButton="false" :show.sync="showGlossary" :fullscreenWindow="true">
        <iframe :src="glossaryUrl" style="width:100%;height:100%" />
    </FloatingWindow>




    <div class="Flex--col Card hide-on-print" style="padding:20px;min-width:320px;max-width:320px">
        <h3>Indikator:</h3>
        <select v-model="indicator" class="Input">
            <option v-if="indicator==null" :value="null">Bitte wählen</option>
            <option v-for="idc in getIndicators(null, 'M')" :value="idc">{{idc.name}}</option>
        </select>

        <template v-if="indicator != null">

            <p>
                <Superbutton label="Glossar" icon="tivigi/img/question.svg" @click="openGlossary(getGlossaryLink(indicator.code))" alt="Glossar zum Themenbereich öffnen" title="Glossar zum Themenbereich öffnen" />
            </p>

            <p>
                <Superbutton label="Drucken" icon="/img/print.svg" :set="true" @click="print()" />
            </p>
            <p style="margin-top:0px;font-size:0.9em">Empfohlen wird der Druck im Querformat.</p>


        </template>
    </div>


    <div class="Flex--col Card" style="padding:20px">
        <h1 class="hide-on-screen">STATISTIKMONITOR Rhein-Neckar</h1>
        <h1>Europäische Metropolregionen in Deutschland im Vergleich</h1>

        <template v-if="indicator != null">


            <h2>{{indicator.name}} ({{latestYear}})</h2>

            <!-- TODO: 3 This table is the same as in Basismodul. Share the code! -->
            <table class="Table">
                <tr>
                    <th>Metropolregion</th>
                    <th style="width:80%;"></th>
                    <th class="numeric" style="width:10%;">{{latestYear}}</th>
                </tr>
                <tr v-for="su in getSpatialUnits(['M'])" :class="getCssClass(su)">

                    <td style="white-space: nowrap;">{{su.properties.name}}</td>
                    <td>

                        <BarDisplay style="width:100%" :value="getValue(su, indicator.code, latestYear)" :max="max" min="0" />


                    </td>
                    <td class="numeric">
                        {{getValue(su, indicator.code, latestYear) | formatNumber(indicator.decimal_places)}}
                    </td>
                </tr>
            </table>

            <p>
                Hannover-Br-Gö-Wo = Hannover-Braunschweig-Göttingen-Wolfsburg
            </p>

        </template>
        <template v-else>
            <p class="Statistikmonitor__Hint">Bitte wählen Sie einen Indikator.</p>
        </template>
    </div>
</div>